const API_KEY = process.env.REACT_APP_BARCODE_LOOKUP_API_KEY;
const API_BASE_URL = (process.env.REACT_APP_BARCODE_LOOKUP_BASE_URL || '/v3/products').trim();

const buildApiUrl = (params) => {
  const url = new URL(
    API_BASE_URL.startsWith('http')
      ? API_BASE_URL
      : API_BASE_URL.startsWith('/')
        ? `${window.location.origin}${API_BASE_URL}`
        : `${window.location.origin}/${API_BASE_URL}`
  );

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });

  url.searchParams.set('formatted', 'y');
  url.searchParams.set('key', API_KEY);
  return url.toString();
};

const mapProduct = (product, barcodeValue) => ({
  name: product.title || '',
  brand: product.brand || '',
  model: product.model || '',
  description: product.description || '',
  category: product.category || '',
  images: (product.images && product.images.length > 0) ? [...product.images] : [],
  manufacturer: product.manufacturer || '',
  barcode: barcodeValue || product.barcode_number || '',
});

const validateApiKey = () => {
  if (!API_KEY || API_KEY === 'your_barcode_lookup_api_key_here') {
    throw new Error('Barcode Lookup API key is not configured. Please set REACT_APP_BARCODE_LOOKUP_API_KEY in your .env file.');
  }
};

const handleResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    if (response.status === 404) {
      throw new Error('No products found');
    }
    if (response.status === 403) {
      throw new Error('Invalid API key or API limit reached');
    }
    throw new Error(`Lookup failed (HTTP ${response.status}): ${text}`);
  }

  if (contentType.includes('text/html')) {
    throw new Error(
      'Barcode Lookup returned HTML instead of JSON. In production this usually means the proxy or Amplify rewrite for /v3 is missing.'
    );
  }

  const data = await response.json();
  if (!data.products || data.products.length === 0) {
    throw new Error('No products found');
  }
  return data.products;
};

export const lookupBarcode = async (barcode) => {
  validateApiKey();

  if (!barcode || barcode.trim() === '') {
    throw new Error('Please enter a barcode number');
  }

  const url = buildApiUrl({ barcode: barcode.trim() });
  const response = await fetch(url);
  const products = await handleResponse(response);
  return mapProduct(products[0], barcode.trim());
};

export const searchByTerm = async (query) => {
  validateApiKey();

  if (!query || query.trim() === '') {
    throw new Error('Please enter a search term');
  }

  const url = buildApiUrl({ search: query.trim() });
  const response = await fetch(url);
  const products = await handleResponse(response);
  return products.map(p => mapProduct(p));
};
